/**
 * This is the changepassword routes configuration.
 * Only configure routes in this file.
 * @memberOf changepassword Module
 * @namespace changepassword Routes
 */
import changepasswordTemplate from './changepassword.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf changepassword Module.changepassword Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the changepassword state and assign the template and controller. */
    $stateProvider
		.state('login.changepassword', {
			url: '^/login/changepassword',
			template: changepasswordTemplate,
			controller: 'changepasswordController',
			controllerAs: 'vm'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/changepassword/changepassword.route.js